<template>
  <a-form :form="form" @submit="submit" class="orderForm">
    <a-form-item
      v-bind="formItemLayout"
      v-for="(item,index) in orderParams"
      :key="index"
      :label="item.label"
      :class="item.key =='is_first_order'?'radio_item':''"
    >
      <div v-if="item.key == 'cloud_thumb'">
        <a-upload
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          class="uploadItem"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="fileList"
          @preview="imgPreview"
          @change="imgChange"
          v-decorator="[item.key, { rules: [ {required: true, message: item.label}]}]"
        >
          <div v-if="fileList.length < 10">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">云资源下单成功截图，最多上传10张图片</div>
        <a-modal :visible="previewVisible" :footer="null" @cancel="imgCancel">
          <img alt="example" style="width: 100%" :src="previewImage">
        </a-modal>
      </div>
      <div v-else-if="item.key == 'is_first_order'">
        <a-radio-group
          v-decorator="[item.key,{initialValue:1},{ rules: [ {required: true, message: item.label}]}]"
        >
          <a-radio :value="1">是</a-radio>
          <a-radio :value="2">否</a-radio>
        </a-radio-group>
      </div>
      <div v-else-if="item.key == 'customer_manager_area'">
        <a-cascader
          class="orderInput"
          :options="options"
          :loadData="loadData"
          placeholder="请选择区域"
          @change="areaChange"
          :fieldNames="{ label: 'name', value: 'id', children: 'children'}"
          v-decorator="[item.key,{ rules: [ {required: 'areaCheck',  message:'请选择'+item.label}]}]"
        />
      </div>
      <div v-else-if="item.key == 'client_company_name'">
        <a-input
          class="orderInput"
          autocomplete="off"
          v-decorator="[item.key,{ rules: [ {required: false,message:'请填写长度' +item.max +'以内的'+item.label,max:item.max}]}]"
        />
      </div>
      <div v-else-if="item.key == 'xcx_order_id'">
        <a-input
          class="orderInput"
          autocomplete="off"
          v-decorator="[item.key, { rules: [ {required: true, message: item.label}]}]"
          @change="getOrderTime"
        />
      </div>
      <div v-else-if="item.key == 'customer_manager'">
        <a-input
          class="orderInput"
          autocomplete="off"
          v-decorator="[item.key, { rules: [ {required: true, message:'请填写长度' +item.max +'以内的'+item.label,max:item.max}]}]"
        />
        <a-radio-group
          class="quikEnter"
          buttonStyle="solid"
          v-if="localInfo.customer_manager.length"
          @change="customer_manager_change"
          size="small"
        >
          <a-radio-button
            class="quikBtn"
            v-for="(item,index) in  localInfo.customer_manager"
            :key="index"
            :value="index"
          >{{item.name}}</a-radio-button>
        </a-radio-group>
      </div>
      <div v-else-if="item.key == 'support_manager'">
        <a-input
          class="orderInput"
          autocomplete="off"
          v-decorator="[item.key, { rules: [ {required: true, message:'请填写长度' +item.max +'以内的'+ item.label,max:item.max}]}]"
        />
        <a-radio-group
          class="quikEnter"
          buttonStyle="solid"
          v-if="localInfo.support_manager.length"
          @change="support_manager_change"
          size="small"
        >
          <a-radio-button
            class="quikBtn"
            v-for="(item,index) in  localInfo.support_manager"
            :key="index"
            :value="index"
          >{{item.name}}</a-radio-button>
        </a-radio-group>
      </div>
      <div v-else-if="item.key=='buy_time' || item.key=='buy_product'">
        <a-input
          class="orderInput"
          autocomplete="off"
          :readOnly="true"
          v-decorator="[item.key, { rules: [ {required: true, message:item.label}]}]"
        />
      </div>
      <div v-else>
        <a-input
          autocomplete="off"
          class="orderInput"
          :readOnly="item.key=='buy_time' || item.key=='buy_product'"
          v-decorator="[item.key, { rules: [ {required: true, message:'请填写长度' +item.max +'以内的'+item.label,max:item.max || '-' }]}]"
        />
      </div>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
      <a-button html-type="submit" class="submit-btn" type="primary">提交订单</a-button>
    </a-form-item>
  </a-form>
</template>


<script>
import { throttle } from "../../utils/util.js";
const orderParams = [
  {
    label: "客户名称",
    key: "client_name",
    value: "",
    max: 30
  },
  {
    label: "公司名称",
    key: "client_company_name",
    value: "",
    max: 30
  },
  {
    label: "客户电话",
    key: "client_phone",
    value: "",
    max: 11
  },
  {
    label: "订单号码",
    key: "xcx_order_id",
    value: ""
  },
  {
    label: "购买产品",
    key: "buy_product",
    value: ""
  },
  {
    label: "购买时间",
    key: "buy_time",
    value: ""
  },
  {
    label: "小程序订单金额",
    key: "xcx_price",
    value: "",
    max: 10
  },
  {
    label: "云资源订单金额",
    key: "cloud_price",
    value: "",
    max: 10
  },
  {
    label: "云资源下单截图",
    key: "cloud_thumb",
    value: []
  },
  {
    label: "客户经理姓名",
    key: "customer_manager",
    value: "",
    max: 10
  },
  {
    label: "客户经理电话",
    key: "customer_manager_mobile",
    value: "",
    max: 11
  },
  {
    label: "客户经理地区",
    key: "customer_manager_area",
    value: ""
  },
  {
    label: "客户经理部门",
    key: "department",
    value: "",
    max: 30
  },
  {
    label: "首单",
    key: "is_first_order",
    value: 1
  },
  {
    label: "支撑经理姓名",
    key: "support_manager",
    value: "",
    max: 10
  },
  {
    label: "支撑经理电话",
    key: "support_manager_mobile",
    value: "",
    max: 11
  }
];
const formItemLayout = {
  labelCol: {
    xs: { span: 6 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 18 },
    sm: { span: 18 }
  }
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 6,
      offset: 6
    },
    sm: {
      span: 16,
      offset: 8
    }
  }
};
export default {
  data() {
    return {
      formItemLayout,
      tailFormItemLayout,
      orderParams,
      previewVisible: false,
      previewImage: "",
      fileList: [],
      options: [],
      area: [],
      selectedOptions: [],
      hasSubmit: false,
      localInfo: {
        customer_manager: [],
        support_manager: [],
        area: {}
      }
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.getArea();
  },
  munted() {},
  methods: {
    submit(e) {
      e.preventDefault();
      if (this.hasSubmit) return;
      //图片数据处理
      let cloud_thumb_value = this.fileList.map((v, k) => {
        return v.response ? v.response.data : "";
      });
      this.form.setFieldsValue({
        cloud_thumb: cloud_thumb_value
      });

      let flag = true;
      let data = "";
      //必填项校验
      this.form.validateFieldsAndScroll(
        {
          scroll: {
            onlyScrollIfNeeded: true,
            offsetTop: 120
          }
        },
        (err, values) => {
          data = values;
          if (!err) {
            flag = false;
          }
        }
      );
      if (flag) {
        return;
      }
      //省市数据处理
      let newData = JSON.parse(JSON.stringify(data));
      let area = data.customer_manager_area;
      let selectedOptions = this.selectedOptions;
      Object.assign(newData, {
        province: selectedOptions[0].name || "",
        city: selectedOptions[1].name || "",
        area: selectedOptions[2].name || "",
        province_id: area[0] || "",
        city_id: area[1] || "",
        area_id: area[2] || ""
      });

      newData.spec = "";
      delete newData.customer_manager_area;
      this.hasSubmit = true;
      axios({
        url: "/api/WorkOrder/create",
        method: "POST",
        data: newData
      })
        .then(res => {
          if (res.data.status == 0) {
            this.$router.push(`/myOrder`);
          }
          this.hasSubmit = false;
        })
        .catch(err => {
          this.hasSubmit = false;
        });
    },
    //获取速填信息
    getLocalInfo() {
      //客户经理
      axios({
        url: "/api/WorkOrder/Manager",
        method: "POST",
        data: {
          type: 0
        }
      }).then(res => {
        if (res.data.status == 0) {
          let data = res.data.data;
          this.localInfo.customer_manager = data || [];
        }
      });
      //支撑经理
      axios({
        url: "/api/WorkOrder/Manager",
        method: "POST",
        data: {
          type: 1
        }
      }).then(res => {
        if (res.data.status == 0) {
          this.localInfo.support_manager = res.data.data || [];
        }
      });
    },
    //客户经理速填
    customer_manager_change(e) {
      let index = e.target.value;
      let data = this.localInfo.customer_manager[index];
      this.form.setFieldsValue({
        customer_manager: data.name,
        customer_manager_mobile: data.mobile,
        department: data.department
      });
      if (this.options[data.region_ids[0] - 1].children) {
        this.form.setFieldsValue({
          customer_manager_area: data.region_ids
        });
        this.selectedOptions = [
          { name: data.province },
          { name: data.city },
          { name: data.area }
        ];
        return;
      }
      axios({
        url: "/api/workOrder/getRegionList",
        method: "POST",
        data: {
          pid: data.region_ids[0]
        }
      }).then(city => {
        let cityList = city.data.data;
        let cityData = cityList.map((v, k) => {
          return Object.assign(v, {
            isLeaf: false,
            key: "city"
          });
        });
        console.log(cityData);

        axios({
          url: "/api/workOrder/getRegionList",
          method: "POST",
          data: {
            pid: data.region_ids[1]
          }
        }).then(area => {
          let areaList = area.data.data;
          let areaData = areaList.map((v, k) => {
            return Object.assign(v, {
              isLeaf: true,
              key: "area"
            });
          });
          cityData.map((v, k) => {
            if (v.id == data.region_ids[1]) {
              cityData[k].children = areaData;
              this.options[data.region_ids[0] - 1].children = cityData;
            }
          });
          this.form.setFieldsValue({
            customer_manager_area: data.region_ids
          });
          this.selectedOptions = [
            { name: data.province },
            { name: data.city },
            { name: data.area }
          ];
        });
      });
    },
    //支撑经理速填
    support_manager_change(e) {
      let index = e.target.value;
      let data = this.localInfo.support_manager[index];
      this.form.setFieldsValue({
        support_manager: data.name,
        support_manager_mobile: data.mobile
      });
    },
    //限制只能输入数字
    ifNumber(e) {
      const { value } = e.target;
      const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
      console.log(e);
      if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
        this.value = value;
      }
    },
    //取消预览
    imgCancel() {
      this.previewVisible = false;
    },
    //图片预览
    imgPreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    beforeUpload(file) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      return flag;
    },
    //上传图片
    imgChange({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.fileList = fileList;
    },
    //三级联动
    areaChange(value, selectedOptions) {
      this.selectedOptions = selectedOptions;
      this.area = this.options[value[0] - 1];
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      let pid = targetOption.id;
      targetOption.loading = true;
      this.getArea(pid, res => {
        targetOption.loading = false;
        let list = res.data.data.reverse();
        let key = targetOption.key == "provice" ? "city" : "area";
        let isLeaf = targetOption.key == "area";
        let options = list.map((v, k) => {
          return Object.assign(v, {
            isLeaf: isLeaf,
            key: key
          });
        });
        targetOption.children = options || [];
        this.options = [...this.options];
      });
    },
    getArea(pid, callback) {
      let _this = this;
      axios({
        url: "/api/workOrder/getRegionList",
        method: "POST",
        data: {
          pid: pid || ""
        }
      }).then(res => {
        if (res.status == 0) {
          if (pid) {
            callback(res);
            return;
          }
          let list = res.data.data.reverse();
          let options = list.map((v, k) => {
            return Object.assign(v, {
              isLeaf: false,
              key: "province"
            });
          });
          _this.options = options;
          this.getLocalInfo();
        }
      });
    },
    //获取订单信息
    getOrderTime(e) {
      let _this = this;
      throttle(this, {
        callback() {
          axios({
            url: "/api/workOrder/order",
            method: "POST",
            data: {
              xcx_order_id: e.target.value
            }
          }).then(res => {
            let data = res.data.data;
            if (Array.isArray(data)) {
              _this.$message.error("请填写有效订单号");
              return;
            }
            _this.form.setFieldsValue({
              buy_product: data.name,
              buy_time: data.add_time
            });
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.orderForm {
  width: 675px;
}
.orderForm .orderInput,
.orderForm .orderInput >>> .ant-cascader-input {
  width: 330px;
  height: 40px;
  line-height: 40px;
  border-color: #dcdfe6;
}
.orderForm > .ant-form-item {
  margin-bottom: 20px;
}
.orderForm > .radio_item {
  margin-bottom: 0;
  position: relative;
  top: -10px;
}
.submit-btn {
  border-radius: 16px;
}
.uploadplus {
  font-size: 30px;
  color: #cfcdcd;
}
.uploadItem .ant-upload-select-picture-card {
  background: #f8f9fb;
}
.enter-tip {
  width: 100%;
  color: #9fa5bb;
  font-size: 14px;
  display: flex;
  height: 1em;
  line-height: 1em;
}
.quikEnter {
  display: flex;
  flex-wrap: wrap;
}
.quikEnter .ant-radio-button-wrapper {
  margin-right: 10px;
  border-radius: 16px;
  border: 1px solid #d9d9d9;
  box-shadow: none !important;
  max-width: 100px;
  min-width: 60px;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  background: rgba(48, 145, 242, 0.1);
  color: #3091f2;
  border: none;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
}
.quikEnter .ant-radio-button-wrapper-checked {
  color: #fff;
  background: #3091f2;
  border: none;
}
.quikBtn >>> span:last-of-type {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  white-space: nowrap;
  text-align: center;
}
.quikBtn::before {
  display: none;
  box-shadow: none;
}
.uploadItem >>> .ant-upload-list {
  float: none;
}
.orderForm >>> .ant-form-item-required::before {
  content: "·";
  color: #ff7200;
  font-size: 18px;
}
.orderForm >>> .ant-form-item-required::after,
.orderForm >>> .ant-form-item-label label::after {
  margin-right: 20px;
}
</style>
